function getAttributes(attr, key) {
    if (attr) { 
        const result = attr.find( x => x.key === key);
        if (result) {
            return result["value"]
        }
    }
}

export { getAttributes }